/**
 * 钱包检测工具
 * 用于检测当前环境是否支持主流钱包
 */

/**
 * 检测当前环境是否带有钱包
 * @returns {Object} 返回检测结果，包含是否有钱包和钱包信息
 */
export function testJSBridge() {
    const bridges = [
        { name: 'MetaMask', check: () => typeof window.ethereum !== 'undefined' && window.ethereum.isMetaMask },
        { name: 'Trust Wallet', check: () => typeof window.trustwallet !== 'undefined' },
        { name: 'TokenPocket', check: () => typeof window.ethereum !== 'undefined' && window.ethereum.isTokenPocket },
        { name: 'imToken', check: () => typeof window.imToken !== 'undefined' },
        { name: 'WalletConnect', check: () => typeof window.WalletConnect !== 'undefined' }
    ];

    const detectedWallets = [];
    
    for (const bridge of bridges) {
        try {
            if (bridge.check()) {
                detectedWallets.push(bridge.name);
            }
        } catch (error) {
            console.warn(`检测 ${bridge.name} 时出错:`, error);
        }
    }

    return {
        hasWallet: detectedWallets.length > 0,
        wallets: detectedWallets,
        message: detectedWallets.length > 0 
            ? `检测到钱包: ${detectedWallets.join(', ')}`
            : '未检测到任何支持的钱包'
    };
}

/**
 * 获取推荐的钱包列表
 * @returns {Array} 推荐钱包列表
 */
export function getRecommendedWallets() {
    return [
        {
            name: 'MetaMask',
            description: '最流行的浏览器钱包扩展',
            downloadUrl: 'https://metamask.io/download/',
            icon: '🦊'
        },
        {
            name: 'Trust Wallet',
            description: '移动端友好的多链钱包',
            downloadUrl: 'https://trustwallet.com/download',
            icon: '🛡️'
        },
        {
            name: 'TokenPocket',
            description: '支持多链的综合性钱包',
            downloadUrl: 'https://www.tokenpocket.pro/en/download/official',
            icon: '🅿️'
        }
    ];
}